import { useMemo } from 'react';

import TextFormatter from '@/modules/admin/views/errors/components/Grid/useColumns/TextFormatter';
import { getInfo, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, deleteAction, editAction, duplicateAction, defaultActionsColumn, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Name', info => <NameAndCreateDateFormatter info={info} />, { initialSize: 'max-w-[20vw]' }),
    defaultColumn('slug', 'Slug', undefined, { enableTruncate: true }),
    defaultColumn('method'),
    column.accessor('url', {
      header: 'URL',
      cell: info => <TextFormatter info={info} value={new URL(getInfo(info)?.value).origin} />,
      enableSorting: false,
      initialSize: 'max-w-[20vw]',
      enableTruncateTooltip: true,
    }),
    column.accessor('request_config.cache_ttl', {
      header: 'Cache TTL (Seconds)',
      defaultVisible: false,
      enableSorting: false,
    }),
    column.accessor('request_config.timeout', {
      header: 'Request Timeout (Milliseconds)',
      defaultVisible: false,
      enableSorting: false,
    }),
    column.accessor('request_config.auth', {
      header: 'Auth',
      cell: info => info.getValue()?.selected || 'No Auth',
      defaultVisible: false,
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction),
  ], [])
}
